<template>
    <div class="page-wrapper survey-page">
        <div class="page-content">
            <TopBarImage :isShowLogo="false"></TopBarImage>
            <div class="page-heaer">
                <img class="back-icon" src="@/assets/icon/survey/ic-back.svg" alt="back-icon"
                    @click="goBack()">
                {{ lbl.survey.header }}
            </div>
            <div class="wrapper-survey">
                <div class="content-container">
                    <div>
                    <div class="header">
                        {{ lbl.survey.title }}
                    </div>
                    <InputDropdown
                        v-model="form_survey.skin_type"
                        :inputLbl="lbl.survey.skin_type"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[0]"
                        :isShowErrorLbl="true"
                        :itemList="skinTypeList"
                        :isRequired="true"
                        @input="onFormUpdate($event)"
                    ></InputDropdown>
                    <div class="skin_issues">
                        <div class="title">
                            {{ lbl.survey.skin_issues.title }}
                            <span class="required"> *</span>
                        </div>
                        <div class="list" >
                            <div v-for="(item, key) in skinIssueList" :key="key" class="item"  @click="selectIssue(item)">
                                <img v-if="item.active" src="../../../assets/icon/survey/ic-check.svg" alt="">
                                <img v-else src="../../../assets/icon/survey/ic-uncheck.svg" alt="">
                                <div class="text">{{ item.text }}</div>
                            </div>
                        </div>
                    </div>
                    <InputDropdown
                        v-model="form_survey.products_used"
                        :inputLbl="lbl.survey.products_used"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[1]"
                        :isShowErrorLbl="true"
                        :itemList="productsUsedList"
                        :isRequired="true"
                        @input="onSelectProduct()"
                    ></InputDropdown>
                    <TextAreaInput
                        v-if="isShowOtherProductInput"
                        v-model="form_survey.other_product" 
                        inputId="other_product_input"
                        :inputLbl="lbl.survey.other_product"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[2]"
                        @input="onFormUpdate()"/>
                    </div>
                    <div class="button-position">
                        <Button
                            btnId="survey"
                            :isBtnDisable="!isFormValid"
                            :btnMsg="lbl.default.confirm"
                            @clickButton="onSubmit()"/>
                    </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
// helper
import Util from '@/helper/Utility';
import FormHelper from '@/helper/FormHelper.js';
import Account from '@/helper/AccountHelper.js';
import CacheHelper from "@/helper/CacheHelper.js";
// mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from '@/mixin/LocaleMixin';
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from '@/mixin/ModalMixin';
//component
import TopBarImage from '@/components/Layout/TopbarImage/TopBarImage.vue';
import InputDropdown from '@/components/Input/Dropdown.vue'
import TextAreaInput from '@/components/Input/TextAreaInput.vue'
import Button from '@/components/Button/Button.vue'
import ModalMaster from '@/components/Modal/ModalMaster.vue'
export default {
    name: 'SurveyEditProfile',
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, AccountMixin],
    components: {
        TopBarImage,
        InputDropdown,
        TextAreaInput,
        Button,
        ModalMaster,
    },
    data: function() {
        return {
            isFirstSave: true,
            isFormValid: false,
            errorInfo: [],
            form_survey: {
                skin_type: '',
                skin_issues: [],
                products_used: '',
            },
            skinTypeList: [
                {text: 'ผิวธรรมดา', value: 'ผิวธรรมดา'},
                {text: 'ผิวแพ้ง่าย', value: 'ผิวแพ้ง่าย'},
                {text: 'ผิวมัน เป็นสิว', value: 'ผิวมัน เป็นสิว'},
                {text: 'ผิวผสม', value: 'ผิวผสม'},
                {text: 'ผิวแห้งขาดน้ำ', value: 'ผิวแห้งขาดน้ำ'},
            ],
            skinIssueList: [
                {text: 'สิว', value: 'สิว', active: false},
                {text: 'ริ้วรอย', value: 'ริ้วรอย', active: false},
                {text: 'ผิวแพ้ง่าย', value: 'ผิวแพ้ง่าย', active: false},
                {text: 'ผิวแห้ง', value: 'ผิวแห้ง', active: false},
                {text: 'ผิวไม่กระชับ หย่อนคล้อย', value: 'ผิวไม่กระชับ หย่อนคล้อย', active: false},
                {text: 'ผิวไม่กระจ่างใส', value: 'ผิวไม่กระจ่างใส', active: false},
            ],
            productsUsedList: [
                {text: 'Bioderma', value: 'Bioderma'},
                {text: 'เคาน์เตอร์แบรนด์', value: 'เคาน์เตอร์แบรนด์'},
                {text: 'เวชสำอาง', value: 'เวชสำอาง'},
                {text: 'แบรนด์อื่นๆ (other)', value: 'แบรนด์อื่นๆ (other)'},
            ],
            isShowOtherProductInput: false,
            other_product: '',
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(3);
        this.setCacheData();
        this.initialOtherModal();
    },
    methods: {
        setCacheData() {
            let cache = new CacheHelper('session');
            this.formProfile = cache.getCache('profile');
            this.profileAddress = cache.getCache('profileAddress');
        },
        goBack() {
            this.$router.back();
        },
        onFormUpdate() {
            let valid = FormHelper.validate(this.errorInfo) && this.isSkinIssueListValid() && this.validateInput();
            this.isFormValid = valid;
        },
        selectIssue(item) {
            item.active = !item.active;
            this.form_survey.skin_issues = this.skinIssueList.filter(item => item.active).map(item => item.value);
            this.onFormUpdate()
        },
        isSkinIssueListValid() {
            return this.skinIssueList.some(item => item.active);
        },
        validateInput() {
            if (this.form_survey.products_used !== 'แบรนด์อื่นๆ (other)') return true;
            return this.form_survey.products_used === 'แบรนด์อื่นๆ (other)' && !Util.isEmptyStr(this.form_survey.other_product);
        },
        onSelectProduct() {
            this.onFormUpdate();
            if (this.form_survey.products_used !== 'แบรนด์อื่นๆ (other)') {
                this.form_survey.other_product = '';
                this.isShowOtherProductInput = false;
            } else {
                this.isShowOtherProductInput = true;
            }
        },
        onSubmit() {
            if (!this.isFormValid) return;
            if (!Util.isEmptyStr(this.form_survey.other_product)) {
                this.form_survey.products_used = this.form_survey.other_product;
            }
            let formData = {
                skin_type: this.form_survey.skin_type,
                skin_issues: this.form_survey.skin_issues,
                products_used: !Util.isEmptyStr(this.form_survey.other_product) ? this.form_survey.other_product : this.form_survey.products_used,
            }
    
            let extendjsonstring = JSON.stringify(formData);
            this.callApiUpdateProfile(extendjsonstring);
        },
        callApiUpdateProfile: function (extendjsonstring) {
            this.loadingModal.show();
            console.log('profile: ', this.formProfile);
            Account.apiUpdateProfile(this.formProfile, this.profileAddress, extendjsonstring)
                .then((res) => {
                    console.log('res: ', res);
                    
                    this.loadingModal.hide();
                    this.isLoading = false;
                    // this.clearCache();
                    if (res && res.objUser && res.objUser.buzzebees) {
                        this.checkBadge(res);
                    } else {
                        this.showSuccessPopup();
                    }
                }).catch(err => {
                    this.loadingModal.hide();
                    this.isLoading = false;

                    this.errorApi(err);
                });
            this.isFirstSave = false;
        },
        clearCache() {
            let cache = new CacheHelper('session');
            cache.removeCache('profile');
            cache.removeCache('profileAddress');
        },
        showSuccessPopup() {
            this.successModal
                .clearText()
                .setMsg(this.lbl.edit_profile.update_success)
                .setBtnOk(this.lbl.edit_profile.btn_confirm)
                .setTag('edit-profile')
                .show();

            this.successModal
                .onClickOk((data) => {
                    if(data.tag == 'edit-profile'){
                        var cache = new CacheHelper('session');
                        cache.setCache('isFromEditProfile', true);
                        this.$router.push('/profile');
                    }
                });
        },
        checkBadge: function(res){
            if(res.objUser){
                if(res.objUser.buzzebees){
                    var badges = res.objUser.buzzebees.badges;
                    if (badges) {
                        console.log("badges", badges);

                        var mission_point = badges.filter(
                            o => o.id == "BiodermaUpdateProfile"
                        )[0];

                        if(mission_point && mission_point.points){
                            this.missionSuccessModal
                                .clearText()
                                .setPoint(mission_point.points)
                                .setTag('mission-update-profile')
                                .show();
                            
                            this.missionSuccessModal.onClickOk((data) =>{
                                if(data.tag == 'mission-update-profile'){
                                    this.getUserLastestPoint();
                                    this.$router.push('/mission');
                                }
                            });

                            this.missionSuccessModal.onClickPage((data) =>{
                                if(data.tag == 'mission-update-profile'){
                                    this.$router.push('/history/earn');
                                }
                            })
                        }
                    }
                }
            }
        },
    }
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import '@/style/input/BaseButton.scss';
@import "../../Register/style/survey.scss";
</style>